import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import Form from './Form';
import Table from "./Table";
import { useDispatch, useSelector } from 'react-redux';
import { getDurations } from '../analyzeSlice';
import CustomLoadingScreen from '../../../components/ui/CustomLoadingScreen';
import { pushRoute } from '../../../store/globalSlice';

export default function QuotaDetails() {
  const dispatch = useDispatch();
  const isLoading = useSelector(store => store.analyze.isLoading);
  // console.log("isLoading", isLoading);
  useEffect(()=> {
    dispatch(pushRoute("quota-details"));
    dispatch(getDurations());
  }, []);
  return (
    <Box>
      <CustomLoadingScreen isLoading={isLoading}/>
      <Form/>
      <Table/>
    </Box>
  )
}
